/*
This file contains only the logic that overrides the default bottom menu when the user clicks on the preview-slideshow
*/

import { BottomMenuPaths } from "../bottom-menu/paths";

/**
 * Get the bottom menu to navigate to when clicked on this zone
 * Only the exceptions are specified, the defaults will happen on selection message
 */
export function updateBottomMenuWhenClicked(
	zoneClicked: eXpress.core.IZone | undefined,
	currentZone: eXpress.core.IZone | undefined,
	currentPath: string | undefined,
): [
	/* New bottom menu path to navigate to */
	newPath: string | undefined,
	/* because a newPath of undefined is also valid, we return a boolean when newPath contains a valid value */
	isSet: boolean,
] {
	// When no zone is clicked, we want to go to the root menu
	if (!zoneClicked) {
		return [BottomMenuPaths.Root, true];
	}

	if (eXpress.core.isAnyTextZone(zoneClicked)) {
		if (currentPath !== BottomMenuPaths.TextValue) {
			// Goto 'text-value' on a second click if text menu (or submenu) is open
			if (zoneClicked === currentZone) {
				// No selection change message
				if (
					currentPath === BottomMenuPaths.Text ||
					currentPath?.startsWith(`${BottomMenuPaths.Text}/`)
				) {
					return [BottomMenuPaths.TextValue, true];
				}
				return [BottomMenuPaths.Text, true];
			}
		}
	}

	return [undefined, false];
}
